<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script >
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  mounted() {
    console.log("app组件挂载");
  },
  methods: {
    /* 页面刷新 */
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
};
</script>

<style lang="scss">
@import './common/styles/cascader.scss';
@import './common/styles/details-content.scss';
#app {
  height: 100%;
  position: relative;
  color: #606266;
  font-family: "Microsoft YaHei", tahoma, arial, "Hiragino Sans";
}
</style>
